<template>
  <div class="presupuesto-interno-facturacion datos">

    <b-card header="Facturación Estimada" class="presupuesto-totales">
      <b-btn class="btn-collapse-card" 
          variant="primary" 
          size="sm"
          @click.prevent="showFacturacion= !showFacturacion">
        <i :class="showFacturacion ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
      </b-btn>
      <b-collapse id="totales" class="mt-2" v-model="showFacturacion">
        <form>
          <b-row>
            <b-col cols="12" md="12">
              <b-table hover
                  responsive="sm" 
                  class="registro"
                  :items="facturacionDatos" 
                  :fields="fields">
                <div slot="table-busy" class="text-center">
                  <b-spinner class="table-spinner" label="Spinning" />
                </div>
                <template v-slot:cell(fechaFacturacion)="data">
                  {{ data.item.fechaFacturacion | fecha }}
                </template>
                <template v-slot:cell(importeFacturacion)="data">
                  {{ data.item.importeFacturacion | moneda }}
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <small>Importe con fee, sin reembolsos ni financiación</small>  
            </b-col> 
          </b-row>
        </form>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'presupuestoInternoDatos/getField',
  mutationType: 'presupuestoInternoDatos/updateField',
});

export default {
  name: 'FacturacionData',
  data () {
    return {
      fields: [
        {
          key: 'fechaFacturacion',
          label: 'Fecha',
        },
        {
          key: 'importeFacturacion',
          label: 'Importe',
          class: 'text-right'
        },
      ],

      showFacturacion: false
    }
  },
  computed: {
    ...mapFields([
      'facturacionDatos',
    ]),
  },  
  created() {
  },
  methods: {
  },
}
</script>

<style>
  .presupuesto-interno-facturacion.datos table thead th {
    border-top: none;
  }
  .presupuesto-interno-facturacion.datos .registro table td[aria-colindex="1"] {
    width: 80%;
  }
  .presupuesto-interno-facturacion.datos .registro table td[aria-colindex="2"] {
    width: 20%;
  }
</style>
